// Aplica la marca (colores + logo) leída de config/general a la página actual.
// Se carga en el index.html de este proyecto (el panel) y, en gastro-saas-cliente,
// en su index.html, pedido.html y mesa.html — siempre antes del script propio de
// cada página, para que quede disponible como función global.
//
// Si config no trae un campo de marca (negocio que todavía no lo configuró),
// no se toca nada y quedan los valores por defecto del CSS.
//
// Campos opcionales en config/general:
//  - colorPrimario, colorPrimarioOscuro, colorAcento, colorFondo: hex (#rrggbb)
//  - logoUrl: data URL base64 de una imagen ya comprimida (mismo mecanismo
//    que las fotos de los platos, sin depender de Firebase Storage)

type CampoDeMarca = "colorPrimario" | "colorPrimarioOscuro" | "colorAcento" | "colorFondo";

interface MarcaDelLocal {
  colorPrimario?: string;
  colorPrimarioOscuro?: string;
  colorAcento?: string;
  colorFondo?: string;
  logoUrl?: string;
}

function aplicarMarca(config: Partial<ConfigLocal> | null | undefined): void {
  if (!config) return;

  const variablesPorCampo: Record<CampoDeMarca, string> = {
    colorPrimario: "--verde",
    colorPrimarioOscuro: "--verde-oscuro",
    colorAcento: "--mostaza",
    colorFondo: "--crema",
  };

  (Object.keys(variablesPorCampo) as CampoDeMarca[]).forEach((campo) => {
    const valor = config[campo];
    if (valor) document.documentElement.style.setProperty(variablesPorCampo[campo], valor);
  });

  // Sin logo cargado no se muestra nada: la caja del logo nace con la clase
  // "oculto" y recién aparece acá. Antes había un <img> apuntando a un archivo
  // inexistente, y el navegador alcanzaba a mostrar su texto alternativo.
  const logo = config.logoUrl || "";
  if (logo) {
    document.querySelectorAll<HTMLImageElement>("[data-logo]").forEach((img) => {
      img.src = logo;
    });
  }
  document.querySelectorAll("[data-logo-caja]").forEach((caja) => {
    caja.classList.toggle("oculto", !logo);
  });
}
